'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const MarketSuppliersError = () => {
  return <ErrorDataUnavailable minHeight="478px" />
}

export default memo(MarketSuppliersError)
